import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';

import { ActionButtonVariants } from 'components/action-button';

import { Quest } from '../use-quests';

import {
  QuestCardContainer,
  QuestCardPicture,
  QuestContent,
  QuestDescription,
  QuestExpirationText,
  QuestTitle,
  RewardLockContainer,
  StyledButton,
  StyledRewardLock,
} from './loyalty-quest-card.styled';

interface IQuestCardProps {
  quest: Quest;
  className?: string;
}

export const QuestCard: FC<IQuestCardProps> = ({ quest, className }) => {
  const { formatMessage } = useIntl();

  return (
    <QuestCardContainer className={className} data-testid="quest-card">
      <QuestCardPicture image={quest.image.locale} alt={quest.title.locale} />

      <RewardLockContainer>
        <StyledRewardLock data-testid="quest-lock" />
      </RewardLockContainer>

      <QuestContent>
        <QuestTitle>{quest.title.locale}</QuestTitle>
        <QuestDescription>{quest.description.locale}</QuestDescription>
        <QuestExpirationText>{quest.expiration.locale}</QuestExpirationText>

        <StyledButton variant={ActionButtonVariants.OUTLINE} maintainWidth>
          {formatMessage({ id: 'details' })}
        </StyledButton>
      </QuestContent>
    </QuestCardContainer>
  );
};
